<template>
	<view style="width: 100%;height: 100%; overflow: hidden;position: absolute;top: 0;left: 0;" @touchmove="move" @touchstart="moveStart" @touchend="moveEnd">
		<view style="position: absolute;left: 20rpx;top: 50rpx;z-index: 999;" @tap="back">	
			<uni-icons type="back" size="60r" color="#fff"></uni-icons>
		</view>
		<image class="vinImg" :src="vinImg" :style="vinImgStyle" @load="setVinImg"></image>
		<view class="zz">
			<view style="border-left: 10rpx solid #fff;border-top: 10rpx solid #fff;width: 25rpx;height: 25rpx;position: absolute;left: 0;top: 0;"></view>
			<view style="border-top: 10rpx solid #fff;border-right: 10rpx solid #fff;width: 25rpx;height: 25rpx;position: absolute;right: 0;top: 0;"></view>
			<view style="border-right: 10rpx solid #fff;border-bottom: 10rpx solid #fff;width: 25rpx;height: 25rpx;position: absolute;right: 0;bottom: 0;"></view>
			<view style="border-left: 10rpx solid #fff;border-bottom: 10rpx solid #fff;width: 25rpx;height: 25rpx;position: absolute;left: 0;bottom: 0;"></view>
		</view>
		<view style="color: #fff;display: flex;align-items: center;justify-content: center;position: absolute;top: 46%;width: 100%;z-index: 999;">
			<view class="btn-father" @tap="scaleUp">
				<uni-icons type="plus" color="#fff" size="60r"></uni-icons>
				<text class="btnDes">放大</text>
			</view>
			<view class="btn-father" @tap="scaleDown">
				<uni-icons type="minus" size="60r" color="#fff"></uni-icons>
				<text class="btnDes">缩小</text>
			</view>
			<view class="btn-father" @tap="turnL">
				<uni-icons type="undo-filled" color="#fff" size="60r" style="margin-left: 16rpx;"></uni-icons>
				<text class="btnDes">左转90°</text>
			</view>
			<view class="btn-father" @tap="turnR">
				<uni-icons type="redo-filled" color="#fff" size="60r" style="margin-left: 16rpx;"></uni-icons>
				<text class="btnDes">右转90°</text>
			</view>
		</view>
		<button class="serch" @tap="doFetch">确认</button>
		<canvas canvas-id="vinImgCanvas" id="vinImgCanvas" style="width: 3000rpx;height: 3000rpx;opacity: 0;"></canvas>
		<text style="position: absolute;top: 20%;color: #fff;left: 33%;z-index: 999;">请将车架号放入到框内</text>
	</view>
</template>

<script>
	const app = getApp();
	export default{
		onLoad(option) {			
			this.vinImg = option.url;
			let that = this
		},
		data() {
			return {
				wb: 0,
				fx: 0,
				fy: 0,
				nx: 0,
				ny: 0,
				sw: 0,
				sh: 0,
				vinImg: '',
				vinImgStyle: '',
				vinImgStyleObj: {position: 'absolute;'},
				vinImgWidth: '',
				vinImgHeigh: '',
				scale: 1,
				rotate: 0,
				resImg: '',
				char: ['','','','','','','','','','','','','','','','',''],
				vin: ''
			}
		},
		methods: {
			back() {
				// #ifdef MP-WEIXIN
				uni.redirectTo({url: '/pages/index/camera'});
				// #endif
				// #ifdef H5
				uni.switchTab({url:'/pages/index/index'})
				// #endif
			},
			scaleUp() {
				this.scale += 0.1
				if (this.scale > 10) {
					this.scale = 10
				}
				this.vinImgStyleObj.width = this.sw * this.scale +'px'
				this.vinImgStyleObj.height = this.wb * this.vinImgHeigh * this.scale + 'px'
				this.setVinImgStyle()
			},
			scaleDown() {
				this.scale -= 0.1
				if (this.scale < 0.5) {
					this.scale = 0.5
				}
				this.vinImgStyleObj.width = this.sw * this.scale +'px'
				this.vinImgStyleObj.height = this.wb * this.vinImgHeigh * this.scale + 'px'
				this.setVinImgStyle()
			},
			turnR() {
				this.rotate++
				if (this.rotate >= 4) {
					this.rotate = 0
				}
				this.vinImgStyleObj.transform = 'rotate(' + this.rotate * 90 + 'deg);'
				this.setVinImgStyle()
			},
			turnL() {
				this.rotate--
				if (this.rotate < 0) {
					this.rotate += 4
				}
				this.vinImgStyleObj.transform = 'rotate(' + this.rotate * 90 + 'deg);'
				this.setVinImgStyle()
			},
			moveStart(e) {
				console.log(e)
				this.fx = e.changedTouches[0].pageX
				this.fy = e.changedTouches[0].pageY
			},
			move(e) {
				this.vinImgStyleObj.left = e.changedTouches[0].pageX - this.fx + this.nx + 'px'
				this.vinImgStyleObj.top = e.changedTouches[0].pageY - this.fy + this.ny + 'px'
				this.setVinImgStyle()
			},
			moveEnd(e) {
				this.nx = e.changedTouches[0].pageX - this.fx + this.nx;
				this.ny = e.changedTouches[0].pageY - this.fy + this.ny;
			},
			img2base64(url,ext)
			{
				// #ifdef MP-WEIXIN
				return 'data:image/jpeg;base64,'+uni.getFileSystemManager().readFileSync(url,'base64')
				// #endif
				
				// #ifdef H5
				return new Promise((reslove,reject) => {
					uni.request({
						url: url,
						method: 'GET',
						responseType: 'arraybuffer',
						success(res) {
							let base64 = 'data:image/jpeg;base64,' + uni.arrayBufferToBase64(res.data)
							reslove(base64)
						},
						fail(err) {
							reject('图片转换失败')
						}
					})
				})
				// #endif
			},
			setVinImg(e) {
				this.vinImgWidth = e.detail.width
				this.vinImgHeigh = e.detail.height
				let that = this
				uni.getSystemInfo({
					success:function(res){
						that.sw = res.screenWidth
						that.sh = res.screenHeight
					}
				})
				this.wb = this.sw / this.vinImgWidth
				this.vinImgStyleObj.width = this.sw * this.scale +'px'
				this.vinImgStyleObj.height = this.wb * this.vinImgHeigh * this.scale + 'px'
				this.vinImgStyleObj.top = '0'
				this.vinImgStyleObj.left = '0'
				this.setVinImgStyle()
			},
			setVinImgStyle() {
				this.vinImgStyle = ''
				let fieldName
				for (let index in this.vinImgStyleObj) {
					fieldName = index.replace(/([A-Z])/g,"-$1").toLowerCase();
					this.vinImgStyle += fieldName+':'+this.vinImgStyleObj[index]+';'
				}
			},
			doFetch() {
				let that = this
				this.ctx = uni.createCanvasContext('vinImgCanvas', this)
				this.ctx.translate(this.nx + this.sw * this.scale / 2,this.ny + this.vinImgHeigh * this.wb * this.scale / 2)
				this.ctx.rotate(Math.PI / 2 * this.rotate)
				this.ctx.drawImage(this.vinImg,this.sw * this.scale / -2,this.vinImgHeigh * this.wb * this.scale / -2,this.sw * this.scale,this.vinImgHeigh * this.wb * this.scale)
				// this.ctx.drawImage(this.vinImg,this.nx,this.ny,this.sw,this.vinImgHeigh * this.wb)
				this.ctx.draw()
				setTimeout(function() {
					uni.canvasToTempFilePath({
						x: that.sw * 0.02,
						y: that.sh * 0.28,
						width: that.sw * 0.96,
						height: 100,
						canvasId: 'vinImgCanvas',
						success: (res) => {
							that.resImg = res.tempFilePath
							uni.setStorageSync('vinBig', that.vinImg);
							// #ifdef MP-WEIXIN
							let data = {img: that.img2base64(res.tempFilePath)}
							app.getApi('POST','data/vinOcr', data, 1, function(result){
								uni.redirectTo({url: '/pages/index/cameraData?isc=0&isad=1&url='+that.resImg+'&data='+JSON.stringify(result)});
							})
							// #endif
							
							// #ifdef H5
							// that.img2base64(res.tempFilePath).then(ress => {
								// let base64 = ress
								let data = {img:res.tempFilePath}
								uni.setStorageSync('vin64', that.resImg);
								app.getApi('POST','data/vinOcr', data, 1, function(result){
									uni.redirectTo({url: '/pages/index/cameraData?isc=0&isad=1&data='+JSON.stringify(result)});
								})
							// })
							// #endif
						}
					}, that)						
				},500)
			}
		}
	}
</script>

<style>
	.btn-father{margin: 0 30rpx;}
	.vinImg{width: 100%;height: 100%;background-repeat: no-repeat;}
	.zz {
		position: absolute;
		left: 2%;
		top: 28%;
		width: 96%;
		height: 100px;
		box-shadow: rgba(0,0,0,.5) 0px 0px 0px 999px;
		z-index: 100;
	}
	.serch {
		background-color: #e7181e;
		color: #fff;
		width: 150rpx;
		height: 60rpx;
		line-height: 60rpx;
		position: absolute;
		bottom: 36%;
		z-index: 999;
		left: 50%;
		margin-left: -75rpx;
	}
	.btnDes {display: block;position: relative;top: -15px;}
</style>
